module.exports = __webpack_public_path__ + "static/img/net1.3ec36d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/net1.jpg
// module id = N5YV
// module chunks = 3